// extracted by mini-css-extract-plugin
export var container = "styles-module--container--J0C0j";
export var content = "styles-module--content--A9h4N";
export var heading = "styles-module--heading--Gu6hH";
export var text = "styles-module--text--sk8SC";
export var tiles = "styles-module--tiles--rqzaq";